import { inject, Component, Input, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from "@angular/material/icon";
import { MatDialogRef } from '@angular/material/dialog';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-disclaimer-content',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './disclaimer-content.component.html',
  styleUrls: ['./disclaimer-content.component.scss']
})
export class DisclaimerContentComponent {

  private dialogRef? = inject<MatDialogRef<DisclaimerContentComponent>>(MatDialogRef, { optional: true });
  private bottomSheetRef? = inject<MatBottomSheetRef<DisclaimerContentComponent>>(MatBottomSheetRef, { optional: true });

  message = `Ketto is committed to transparency and ensuring that all parties understand how donations are utilized. Ketto
    reserves
    the right to first use the donations received to cover the costs involved in creating, marketing, and distributing
    the
    campaign. These costs may include platform fees, license fee, and other operational expenses necessary to
    facilitate the
    campaign. After these costs are deducted, the remaining funds will be disbursed to the campaigner. Ketto reserves
    the
    right to prioritize the coverage of these costs before making payments to the campaigner. This approach ensures
    that our
    platform can effectively support and promote your campaign while maintaining financial integrity.`

  close(data?: any) {
    if (this.bottomSheetRef) {
      this.bottomSheetRef.dismiss(data);
    } else {
      this.dialogRef.close(data);
    }
  }
}
